import produce from "immer";
import find from "lodash/find";
import pullAllBy from "lodash/pullAllBy";
import { CustomizationState } from "../";
import { ContentEditablePicture } from "../../../types/customization/content";
import { SelectionPhoto } from "../../../types/selection/selection";
import { sizeP10kToMm } from "../../../utils/customization/box";
import { calcDefaultCropping } from "../../../utils/customization/cropping";
import { findPage, findPageDefinition } from "../../../utils/customization/finders";
import { addSelectionPhotoToSelection } from "../../../utils/selection/photo";

export interface ChangeEditablePictureElementPictureAction {
  type: "changeEditablePictureElementPicture";
  pageKey: string;
  editablePictureKey: string;
  selectionPhoto: SelectionPhoto;
}

export function changeEditablePictureElementPicture(
  state: CustomizationState,
  action: ChangeEditablePictureElementPictureAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { editablePictureKey, pageKey, selectionPhoto } = action;
    const page = findPage(pageKey, draftState.content);

    const pageDefinition = findPageDefinition(page.pageDefinitionKey, draftState.template);
    const editablePictureDefinition = find(
      pageDefinition.elementDefinitions,
      ({ key }) => key === editablePictureKey
    );
    if (!editablePictureDefinition || editablePictureDefinition.type !== "editable-picture") {
      throw new Error("editablePictureDefinition not found");
    }

    const elementSizeMm = sizeP10kToMm(editablePictureDefinition, pageDefinition);
    const nextRatio = elementSizeMm.width.value / elementSizeMm.height.value;

    const cropping = calcDefaultCropping({
      nextRatio,
      selectionPhoto,
    });

    const editablePicture: ContentEditablePicture = {
      cropping,
      editablePictureKey: editablePictureDefinition.key,
      filterTag: "none",
      selectionPhotoKey: selectionPhoto.key,
    };

    addSelectionPhotoToSelection(selectionPhoto, draftState.selection);
    pullAllBy(page.editablePictures, [editablePicture], "editablePictureKey");
    page.editablePictures.push(editablePicture);
  });
}
